<template>
  <div class="multiple-image-choice">
    <van-checkbox-group v-model="issue.select" icon-size="18px">
      <ul class="image-choice-wrap clearfix">
        <li v-for="item in issue.items" :key="item.id">
          <image-choice-item :item="item" @click="changeValue(item.id)" :class="{ 'choice-checked': issue.select.includes(item.id)  }">
            <template v-slot:icon>
              <van-checkbox shape="square" :name="item.id">
                <template v-slot:icon="{ checked }">
                  <icon-checkbox :value="checked" />
                </template>
              </van-checkbox>
            </template>
            <template v-slot:vote>
              <vote-progress
                  v-if="showVoteProgress && issue.select.length"
                  :vote="question.vote"
                  :label="item.id"
                  :checked="issue.select.includes(item.id)"
                  :selected="!!issue.select.length"
              />
            </template>
          </image-choice-item>
        </li>
      </ul>
    </van-checkbox-group>
  </div>
</template>

<script>
import ImageChoiceItem from '@/questions/components/ImageChoiceItem'
import IconCheckbox from '@/components/base/IconCheckbox'
import { Notify } from 'vant'
import VoteProgress from '../components/VoteProgress.vue'

export default {
  name: 'MultipleImageChoice',
  components: { VoteProgress, IconCheckbox, ImageChoiceItem },
  changeExpr: 'issue.select',
  methods: {
    changeValue(id) {
      let select = this.issue.select.slice()
      let index = select.findIndex(s => s === id)
      if (index > -1) {
        select.splice(index, 1)
      } else {
        select.push(id)
      }
      const max = this.issue.max_choice
      if (max && max > 0) {
        if (select.length > max) {
          Notify({
            type: 'warning',
            message: `最多选择${max}项`
          })
          return
        }
      }
      this.issue.select = select
    }
  }
}
</script>

<style scoped></style>
